import { FormLabel, Box, Typography, RadioGroup, FormControlLabel, Radio, FormControl, FormHelperText, Select, InputAdornment, TextField } from "@material-ui/core";
import { useObserver, FieldType, IModel, EditableInput } from "@shoothill/core";
import MaterialTable from "material-table";
import FormSectionViewModelBase from "Globals/ViewModels/FormSections/FormSectionViewModelBase";
import styled from "styled-components";
import { IViewModel, ViewModelBase } from "@shoothill/core/dist/ViewModels";
import React, { useEffect } from "react";
import { theme } from "Globals/Styles/AppTheme";

export const StyledTypography = styled.p`
    position: absolute;
    z-index: 1;
    font-size: 12px;
    bottom: 5px;
    left: 15px;
`;
export const StyledBox = styled(Box)`
    input {
        padding-left: 30px;
    }
`;

interface IProps<T extends IModel<T>> {
    viewModel: IViewModel<T> & ViewModelBase<T>;
    fieldName: keyof FieldType<T>;
    label?: string;
    smallLabel?: string;
    placeholder?: string;
    onChange?: () => void;
    disabled?: boolean;
}

export function CurrencyInput<T extends IModel<T>>(props: IProps<T>) {
    const { viewModel, label, smallLabel, placeholder, fieldName, onChange, disabled, ...rest } = props;
    return (
        <FormControl component="fieldset">
            <FormLabel component="legend" style={smallLabel != "" ? { marginBottom: "8px" } : { marginBottom: "10px" }}>
                {smallLabel ? label : ""}
            </FormLabel>
            <Box style={{ position: "relative" }}>
                <StyledTypography>£</StyledTypography>
                <StyledBox>
                    <EditableInput
                        type="number"
                        placeholder={placeholder}
                        viewModel={viewModel}
                        fieldName={fieldName}
                        label={smallLabel ? <span style={{ fontSize: "10px" }}>{smallLabel}</span> : <span style={{ fontSize: "12px", fontWeight: "bold" }}>{label}</span>}
                        onChange={() => {
                            if (onChange) {
                                onChange();
                            }
                        }}
                        inputProps={{
                            disabled: disabled,
                        }}
                    />
                </StyledBox>
            </Box>
        </FormControl>
    );
}
